module.exports = __webpack_public_path__ + "img/M0060.ef466308.png";